import { Nullable } from '@/shared/types/app.types'
import { NotificationType } from '@/modules/configurationModule/detail/notifications/models/notification-types'

export interface NotificationTypesModalBasicData {
    emailChannelActive?: boolean,
    inboxChannelActive?: boolean,
    smsChannelActive?: boolean,
    notificationType?: Nullable<NotificationType>,
}

export interface NotificationTypesModalBasicDataForm {
    basicData: NotificationTypesModalBasicData
}
export const initialNotificationTypesModalBasicDataForm =
    (): NotificationTypesModalBasicDataForm => ({
        basicData: {
            notificationType: null,
            inboxChannelActive: false,
            emailChannelActive: false,
            smsChannelActive: false
        }
    })
